export const Base_URL= process.env.REACT_APP_API_BASE_URL
export const Img_URL = process.env.REACT_APP_IMG_URL
export const Telecaller_URL= process.env.REACT_APP_TELECALLER_URL
export const Chat_URL = process.env.REACT_APP_CHAT_URL
